import type { AvatarProps } from '@app/src/components/Ui/Avatar'
import Avatar from '@app/src/components/Ui/Avatar'
import { capitalize } from '@app/src/utils/helpers'
import React, { useEffect, useState } from 'react'

export type CompanyAvatarProps = {
  organizationName: string
  imageUrl?: string
  unlinked?: boolean
} & Omit<AvatarProps, 'children' | 'src'>

const CompanyAvatar: React.FC<CompanyAvatarProps> = ({ organizationName, imageUrl, unlinked, imgProps, ...props }) => {
  const [displaySrc, setDisplaySrc] = useState<string | undefined>(imageUrl)

  useEffect(() => {
    setDisplaySrc(imageUrl)
  }, [imageUrl])

  return (
    <Avatar
      alt={organizationName}
      src={displaySrc}
      imgProps={{
        ...imgProps,
        onError: e => {
          imgProps?.onError?.(e)
          setDisplaySrc(undefined)
        },
      }}
      sx={{ bgcolor: unlinked ? 'grey.500' : 'secondary.main', '& img': { border: 'none' } }}
      {...props}
    >
      {capitalize(organizationName?.[0])}
    </Avatar>
  )
}

export default CompanyAvatar
